<!--
  --
  -- カード支払 コンテンツコンポーネント
  --
  -->
<template>
  <v-list-item-content class="h-16">

    <v-list-item-title class="font-weight-bold">
      <span class="d-none d-sm-inline mr-4">カード支払</span>
      <span>{{pay.cardNo}}</span>
    </v-list-item-title>

    <v-list-item-subtitle class="d-flex">
      <div class="mr-2">{{pay.expire | timeformat('m/Y')}}</div>
      <div>{{pay.holderName}}</div>
    </v-list-item-subtitle>

  </v-list-item-content>
</template>

<script>
export default {
  name: 'CContentCard',
  props: {
    pay: {
      type: Object,
      required: true
    }
  }
}
</script>
